var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.0878982px",
    height: "18px",
    viewBox: "0 0 18.0878982 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1E9CC059-4BFB-4E39-9373-76FE1046C6DD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relationship-Dashboard",
    transform: "translate(-1217.1936, -92.834)",
    fill: "#585858",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-icon",
    transform: "translate(1217.1936, 92.834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5165266,8.19233962 C7.76629048,8.29687871 8.02535779,8.37762697 8.2902867,8.4335116 L8.2902867,18 C8.1278069,17.9581206 7.96966669,17.900921 7.81799157,17.8291698 L1.78869216,15.1461316 C0.701117802,14.6620122 0.000289626196,13.5832092 0,12.3927515 L0,5.70022919 C0.000798900487,5.43183042 0.0379832747,5.16477901 0.110537156,4.90637144 L7.5165266,8.19233962 Z M11.8777198,5.95145 L3.68792148,2.10274721 L1.78869216,2.94684913 C1.44617172,3.09740873 1.1357394,3.31232342 0.874248415,3.57992557 L8.11945655,6.80560075 C8.70810253,7.06683969 9.37979571,7.06683969 9.9684417,6.80560075 L11.8777198,5.95145 Z M17.2136498,3.57992557 C16.9521588,3.31232342 16.6417265,3.09740873 16.2992061,2.94684913 L10.2699067,0.263810888 C9.49044753,-0.0879369628 8.59745071,-0.0879369628 7.81799157,0.263810888 L5.51680896,1.28879179 L13.7066073,5.13749458 L17.2136498,3.57992557 Z M17.9773611,4.90637144 L14.4502209,6.47398929 L14.4502209,8.93595321 C14.4502209,9.35218948 14.1127948,9.68961564 13.6965585,9.68961564 C13.2803222,9.68961564 12.9428961,9.35218948 12.9428961,8.93595321 L12.9428961,7.13721222 L10.5713716,8.19233962 C10.3199843,8.29235907 10.0613084,8.37298533 9.79761155,8.4335116 L9.79761155,18 C9.96009134,17.9581206 10.1182315,17.900921 10.2699067,17.8291698 L16.2992061,15.1461316 C17.3867804,14.6620122 18.0876086,13.5832092 18.0878982,12.3927515 L18.0878982,5.70022919 C18.0870993,5.43183042 18.049915,5.16477901 17.9773611,4.90637144 L17.9773611,4.90637144 Z",
    id: "box"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/productIcon.ddfc47a65e3456a2f0b46006f10e136c.svg";
export { ForwardRef as ReactComponent };